$(document).ready(function() {

  pushDivDescreptiveOffert()


    var allPanels = $('.slide-accordion > .slide-accordion__desc').hide();
    $('.slide-accordion > .slide-accordion__btn').on('click', function() {
    $this = $(this);
    btnAccHeight = $this.outerHeight();
    $target =  $this.next();
    // $('.slide-accordion__close').hide();
    if(!$target.hasClass('slide-accordion__desc--active')) {
      $('.slide-accordion__btn').removeClass('slide-accordion__btn--active');
      $this.addClass('slide-accordion__btn--active');
      // $this.next().find('.slide-accordion__close').show();
      allPanels.removeClass('slide-accordion__desc--active').slideUp();
      $target.addClass('slide-accordion__desc--active').slideDown();
      $('.scroll-to-section').addClass('scroll-to-section--active');
      $('.slide-accordion__close').on('click', function() {
        $(this).parent().prev().removeClass('slide-accordion__desc--active');
      });
      $('.scroll-to-section--active').on('click', function() {
        
        $('html,body').animate({
          scrollTop: $('.slide-accordion__btn--active').offset().top - btnAccHeight - 2
        }, 'slow');
      });

    } else {
      $this.removeClass('slide-accordion__btn--active');
      $target.removeClass('slide-accordion__desc--active').slideUp();
      $('.scroll-to-section').removeClass('scroll-to-section--active');
    }
    return false;
  });






  stickyHeader();
  mobileMenu();
  parksZone();
  popupZones();
  changeOffertView();
  showFastContact();
  playVideoOnClick();
  selectLang();
  categoryFilters();

  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");

  if ($("#opinionsSlider").length > 0) {
    opinionsSlider($("#opinionsSlider"));
  }

  if ($("#certsSlider").length > 0) {
    certsSlider($("#certsSlider"));
  }

  if ($("#sliderLogos").length > 0) {
    sliderLogos($("#sliderLogos"));
  }

  $('.lb-gallery').lightGallery({
    thumbnail: true,
    getCaptionFromTitleOrAlt: false,
    download: false,
    autoplay: false,
    share: false,
    zoom: false,
    autoplayControls: false,
    fullScreen: false,
    selector: '.gallery-item__link'
  });

  $('.realization-tile').each(function (index) {
    $('.realization-tile--'+index).lightGallery({
      thumbnail: true,
      getCaptionFromTitleOrAlt: false,
      download: false,
      autoplay: false,
      share: false,
      zoom: false,
      autoplayControls: false,
      fullScreen: false,
      selector: '.gal'
    });
  });


  $('.slide-accordion__gallery').lightGallery({
      thumbnail: true,
      getCaptionFromTitleOrAlt: false,
      download: false,
      autoplay: false,
      share: false,
      zoom: false,
      autoplayControls: false,
      fullScreen: false,
      selector: '.slide-accordion__gallery-link'
    });

});


$(window).on('scroll', function () {
  stickyHeader();
});

$(window).resize(function () {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");
});


var opinionsSlider = function(el) {
  el.slick({
    fade: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 2000,
    dots: false,
    accessibility: false,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 319,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
};

var certsSlider = function(el) {
  el.slick({
    fade: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 2000,
    dots: false,
    accessibility: false,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 319,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
};

var sliderLogos = function(el) {
  el.slick({
    slidesToShow: 6,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    arrows: true,
  
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 1000,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 1000,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 1000,
          slidesToScroll: 1,
          arrows: true,
        }
      }
    ]
  });
};


function stickyHeader() {
  450 < $(window).scrollTop() ? $(".sticky-header").addClass("sticky-header--active") : $(".sticky-header").removeClass("sticky-header--active");
}


function mobileMenu() {
  var $childMenu = $(".main-menu .menu-item-has-children > a")
  $childMenu.append("<span class='mobile-menu-arrow'></span>");
  $('.mobile-menu-arrow').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('mobile-menu-arrow--active')
    $(this).parent().next().slideToggle('medium');
  });
  $('#mobileBurger').on('click', function() {
    $('.mobile-burger__line').toggleClass('animate');
    $('.main-menu').toggleClass('main-menu--active');
  })
}



function changeOffertView() {
  $graphicsButton = $('#graphicsOffert');
  $descriptiveButton = $('#descriptiveOffer');

  $graphicsButton.on('click', function() {
    $('.descriptive-offert').addClass('descriptive-offert--hidden');
    $('.descriptive-offert').removeClass('descriptive-offert--active');
    $('.graphics-offert').removeClass('graphics-offert--hidden');
    $('.graphics-offert').addClass('graphics-offert--active');
    $('#pushDiv').hide();
    setTimeout(function() { 
      $('.choice-zone').removeClass('choice-zone--hidden');
    }, 200);
  })

  $descriptiveButton.on('click', function() {
    $('.graphics-offert').addClass('graphics-offert--hidden');
    $('.graphics-offert').removeClass('graphics-offert--active');
    $('.descriptive-offert').removeClass('descriptive-offert--hidden');
    $('.descriptive-offert').addClass('descriptive-offert--active');
    $('#pushDiv').show();
    setTimeout(function() { 
      $('.choice-zone').addClass('choice-zone--hidden');
    }, 200);
  })
}


function pushDivDescreptiveOffert() {
  var finalHeightBtns = -250;
  $('.slide-accordion__btn').each(function() {
    btnHeight = $(this).outerHeight();
    finalHeightBtns += btnHeight;
    $('#pushDiv').height(finalHeightBtns);
  });
  $('.slide-accordion > .slide-accordion__btn').on('click', function() {
    descHeight = $(this).next().outerHeight(true);
    finalHeight = finalHeightBtns + descHeight;
    $('#pushDiv').height(finalHeight);
  });
 
}


function showFastContact() {
  $('#showFastContact').on('click', function() {
    $('.contact-pop').toggleClass('contact-pop--active');
  });
  $('.contact-pop__exit').on('click', function() {
    $('.contact-pop').removeClass('contact-pop--active');
  });
}


function parksZone() {
  $('.choice-zone__item').on('mouseover', function() {
    if ($(this).hasClass('choice-zone__item--active')) {
      return;
    } else {
      $zoneNumber = $(this).attr('id');
      $('.choice-zone__item').removeClass('choice-zone__item--active');
      $(this).addClass('choice-zone__item--active');
      var image = $('.choice-zone__photo--fake');
      // $('.choice-zone__polygon').removeClass('choice-zone__polygon--active');
      // $(this).find('.choice-zone__polygon').addClass('choice-zone__polygon--active');
      $('.choice-zone__info').removeClass('choice-zone__info--active');
      $('.choice-zone').find('.'+ $zoneNumber+'').addClass('choice-zone__info--active');
      image.removeClass('choice-zone__photo--active');
      setTimeout(function() { 
        image.addClass('choice-zone__photo--active');
        image.attr('src',document.location.href+'../../wp-content/themes/parktrampolin/images/'+$zoneNumber+'.jpg');
      }, 200);
    }
  });
  $('body').on('click', function() {
    $('.choice-zone__info').removeClass('choice-zone__info--active');
    $('.choice-zone__item').removeClass('choice-zone__item--active');
    $('.choice-zone__photo--fake').removeClass('choice-zone__photo--active');
  })
  $('body').find($('.choice-zone')).on('click', function(e) {
    e.stopPropagation();
  });

}


function popupZonesData(title, sections) {
  $title = $(".zone-popup__title");
  $title.text(title);
  $content = $(".zone-popup__content");
  var html = '';

  sections.forEach(function(item, index) {
    html += '<div class="slide-accordion__section">';
    html += '<h5 class="slide-accordion__title">' + item.zone_section_title + '</h5>';
    var photos = item.zone_section_photos;

    if (photos.length > 0) {
      html += '<div class="row slide-accordion__gallery">';
      photos.forEach(function(photo) {
        html += '<div class="col-sm-6 col-lg-4 mt-3 mb-3"><a class="slide-accordion__gallery-link" href="' + photo.url + '" data-lightbox="gallery"><img src="'+ photo.sizes["realizations-thumb"] + '" alt="' + photo.alt + '"/></a></div>';
      });
      html += '</div>';
    }

    html += item.zone_section_text;

    html += '</div>';

    $content.html(html);
  });

  // content loaded dynamically so init lightbox again
  $('.slide-accordion__gallery').lightGallery({
    thumbnail: true,
    getCaptionFromTitleOrAlt: false,
    download: false,
    autoplay: false,
    share: false,
    zoom: false,
    autoplayControls: false,
    fullScreen: false,
    selector: '.slide-accordion__gallery-link'
  });

  
}

function popupZones() {
  $button = $(".choice-zone__btn-more");
  $buttonClose = $('.zone-popup__close');
   $button.on('click', function() {
    $buttonId = $(this).attr('id');
    $popupData = $jsonZonesArray[$buttonId];
    popupZonesData(
      $popupData['title'],
      $popupData['sections'],
    );
    
    
    $('.zone-popup').addClass('zone-popup--active');
    $('body').addClass('h-scroll');

  });

  $buttonClose.on('click', function() {
    $('.zone-popup').removeClass('zone-popup--active');
    $('body').removeClass('h-scroll');
    
  });

  $('.zone-popup').on('click', function(e) {
    if ($(e.target).closest('.zone-popup__container').length != 0) return;
    $('.zone-popup').removeClass('zone-popup--active');
    $('body').removeClass('h-scroll');
  });
}



function playVideoOnClick() {
  $('body').on('click', '.realization-tile__movie', function(e) {
    $buttonId = $(this).attr('id');
    $embedData = $jsonCodesArray[$buttonId];
    $embedCode = $embedData['movie_code'];
   
    $(".video-overlay__iframe").append('<iframe class="video-overlay__video" src="https://www.youtube.com/embed/'+$embedCode+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>')
    $('.video-pop').fadeIn(300);
  });
  $('.video-pop').on('click',function(e) {
    $('.video-pop').fadeOut(300);
    $('.video-overlay__video').remove();
  });
  $('.video-pop').find($('.video-overlay__video')).on('click', function(e){
    e.stopPropagation();
  });
}





function selectLang() {
  var activeLang = $('.language-wrapper__placeholder');
  var langItem = $('.lang__link--active').html();
  activeLang.html(langItem);
  $('.language-wrapper__btn').on('click', function () {
    $('.language-wrapper__list').fadeToggle('slow');
  });

  $(document).click(function (e) {
    if (!$('.language-wrapper__btn').is(e.target)) {
      $('.language-wrapper__list').fadeOut('slow');
    }
  });
}



function categoryFilters() {
  $('.categories-list__label').on('click', function() {
    $('.categories-list__label').removeClass('categories-list__label--active');
    $(this).addClass('categories-list__label--active');
  });

  $('.categories-list__input').on('change', function() {
    var filter = $('#filter');
    var data = filter.serialize();
    var results = 'action=myfilter&' + data;
    $.ajax({
      url: filter.attr('action'),
      data: results,
      type: filter.attr('method'), 
      beforeSend: function() {
        $('.circle-loading').fadeIn(550);
      },
      success:function(data){
        $('.category-filter').html(data); 
        $('.circle-loading').fadeOut(550);
      }

    });
    return false;
  });
}